export default {
  STATES: {
    BREMEN: 'Bremen',
    HAMBURG: 'Hamburg',
    BERLIN: 'Berlin',
    SAARLAND: 'Saarland',
    SCHLESWIG_HOLSTEIN: 'Schleswig Holstein',
    THURINGIA: 'Thuringia',
    SAXONY: 'Saxony',
    RHINELAND_PALATINATE: 'Rhineland Palatinate',
    SAXONY_ANHALT: 'Saxony Anhalt',
    HESSE: 'Hesse',
    MECKLENBURG_POMERANIA: 'Mecklenburg Pomerania',
    BRANDENBURG: 'Brandenburg',
    NORTHRHINE_WESTPHALIA: 'Northrhine Westphalia',
    NORTHRHINE_WESTPHALIA_KV_NORDRHEIN: 'Nordrhein-Westfalen (KV-Nordrhein)',
    NORTHRHINE_WESTPHALIA_KV_WESTFALEN_LIPPE: 'Nordrhein-Westfalen (KV-Westfalen-Lippe)',
    BADEN_WUERTTEMBERG: 'Baden-Wuerttemberg',
    LOWER_SAXONY: 'Lower Saxony',
    BAVARIA: 'Bavaria',
  },
  WEEKDAYS: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ],
  INSTITUTIONS: [
    'Einzelpraxis',
    'Berufsausübungsgemeinschaft',
    'Praxisgemeinschaft',
    'Klinik',
    'MVZ',
  ],
  SERVICES: [
    'Allgemeinärztlicher Dienst',
    'Augenärztlicher Dienst',
    'Kinderärztlicher Dienst',
    'HNO-ärztlicher Dienst',
    'Chirurgischer Dienst',
    'Zahnärztlicher Dienst',
    'Gynäkologischer Dienst',
    'Orthopädischer Dienst',
    'Psychiatrischer Dienst'
  ],
  COUNTING: [
    'first',
    'second',
    'third',
    'fourth',
    'fifth',
    'sixth',
    'seventh',
    'eighth',
    'ninth',
    'tenth',
  ],
};
